import React, { useEffect, useMemo, useState } from 'react'

import { ResponsivePie } from '@nivo/pie'

import { v4 as uniqid } from 'uuid'

import getFormStatus from '@/Form/Functions/getFormStatus'

import ajaxRequest from '@function/ajax/ajaxRequest'

import Loader from '@Pure/Loader'

import bemit from '@function/bemit'

import { num, formatNum } from '@root/utility'

const status_labels =
{
	'pending': 'En attente',
	'validated': 'Validé',
	'disabled': 'Désactivé'
};

const colors =
{
	'pending': '#FED976',
	'validated': '#63998D',
	'disabled': '#E8E8E8'
};

const theme =
{
	text:
	{
		fontSize: 16,
		fontFamily: 'inherit'
	}
};

export default function ECUsersStats ({ ...props })
{
	const [loading, setLoading] = useState(true);
	const [status, setStatus] = useState({ });
	const [data, setData] = useState();
	const [users_count, setUsersCount] = useState();
	const [partners_visits, setPartnersVisits] = useState();

	useEffect(function ()
	{
		(async function ()
		{
			try
			{
				var { users, partners_visits
				} = await ajaxRequest('/statistics/my-EC-stats');
			}
			catch (update)
			{
				setLoading(false);
				return setStatus(update);
			}

			const data = Object.keys(users || { }).map(function (status)
			{
				const config =
				{
					id: status,
					label: status_labels[status],
					value: num(users[status], 0),
					color: colors[status]
				};

				return config;
			});

			const count = (data || []).reduce(function (total, config)
			{
				return num(total, 0) + config.value;
			},
			0);

			setUsersCount(count);
			setPartnersVisits(partners_visits || 0);
			setLoading(false);
			setData(data);
		})();
	},
	[]);

	const loader = loading ?
	(
		<Loader className="c-loader"
			bemit={ ['big', 'primary', 'bg-white'] }
		/>
	)
	: undefined;

	const chart = data ?
	(
		<ResponsivePie data={ data }
			margin={{ top: 20, right: 20, bottom: 30, left: 20 }}
			sortByValue={ true }
			innerRadius={ 0.65 }
			padAngle={ 2 }
			activeOuterRadiusOffset={ 8 }
			colors={ ({ data }) => data.color }
			borderWidth={ 6 }
			borderColor={
			{
				from: 'color'
			} }
			arcLinkLabel="label"
			arcLinkLabelsSkipAngle={ 10 }
			arcLinkLabelsTextColor="#000"
			arcLinkLabelsThickness={2}
			arcLinkLabelsColor={ { from: 'color' } }
			arcLabelsSkipAngle={ 10 }
			arcLabelsTextColor={ data => data.id === 'validated' ? '#FFF' : '#000' }
			defs={
			[
				{
					id: 'dots',
					type: 'patternDots',
					background: 'inherit',
					color: 'rgba(255, 255, 255, 0.3)',
					size: 4,
					padding: 1,
					stagger: true
				},
				{
					id: 'lines',
					type: 'patternLines',
					background: 'inherit',
					color: 'rgba(255, 255, 255, 0.3)',
					rotation: -45,
					lineWidth: 6,
					spacing: 10
				}
			]}
			fill={
			[
				{
					match: { id: 'disabled' },
					id: 'lines'
				},
				{
					match: { id: 'pending' },
					id: 'dots'
				}
			] }
			valueFormat={ val => formatNum(val, '0,0') }
			theme={ theme }
		/>

	)
	: undefined;

	return (
		<div className="u-full-width u-flex u-flex-wrap">

			{ getFormStatus(status) }

			<div className={ bemit('c-chart', ['ec-users']) }>

				<div className="c-chart__content">

					<div className="c-chart__title">
						Utilisateurs
					</div>

					<div className="c-chart__chart">
						{ chart }

						<div className="c-chart__center-value">
							{ formatNum(users_count, '0,0') }
						</div>
					</div>

					{ loader }

				</div>

			</div>

			<div className={ bemit('c-color-block', ['ec-users-charts']) }>
				{ loader }

				<svg className="o-svg-icon o-svg-icon--user c-color-block__icon">
					<use xlinkHref="/images/icons.svg#svg-icon-user"></use>
				</svg>

				<div className="c-color-block__title">
					{ partners_visits }
				</div>

				<div className="c-color-block__txt">
					Visites des pages partenaires ce mois-ci.
				</div>

			</div>

		</div>
	);
}